import { useQuery } from '@tanstack/react-query'
import {
  type DocumentRead,
  documentVersionsQueryOptions,
  isCurrentApproved,
} from '@/entities/document'
import { DateStamp } from '@/shared/ui/date-stamp'
import { FileRow } from '@/shared/ui/file-row'
import { ZoneNote } from '@/shared/ui/zone-badge'

// Файловая часть документа: текущая версия (скачивание + кто/когда/согласование)
// и история версий. Шапка (заголовок/чипы/действия) живёт в EntityPageHeader.
export function DocumentFileTab({ document: doc }: { document: DocumentRead }) {
  const versionsQ = useQuery(documentVersionsQueryOptions(doc.id))
  const approved = isCurrentApproved(doc)
  const versions = versionsQ.data ?? []

  return (
    <div className="flex flex-col gap-4">
      {/* Загрузка, согласование и история версий — все моменты одной вкладки:
          зона названа один раз сверху. */}
      <ZoneNote />
      <section className="flex flex-col gap-2 rounded-card bg-bg-surface p-4 ring-1 ring-border-subtle ring-inset">
        <FileRow file={doc.current_version.file} />
        <p className="text-xs text-text-tertiary">
          Загрузил {doc.current_version.uploaded_by.name || '—'} ·{' '}
          <DateStamp value={doc.current_version.uploaded_at} />
          {doc.current_version.note ? ` · ${doc.current_version.note}` : ''}
        </p>
        {approved && doc.approval && (
          <p className="text-xs text-success">
            Согласовал {doc.approval.by.name || 'заказчик'} · <DateStamp value={doc.approval.at} />
          </p>
        )}
      </section>

      {versions.length > 1 && (
        <section className="flex flex-col gap-3">
          <h2 className="label text-text-secondary">История версий</h2>
          <ul className="flex flex-col gap-2">
            {[...versions].reverse().map((v) => (
              <li
                key={v.number}
                className="flex flex-col gap-1.5 rounded-control bg-bg-surface px-4 py-3 ring-1 ring-border-subtle ring-inset"
              >
                <div className="flex items-center justify-between gap-2">
                  <span className="mono-num text-sm text-text-primary">v{v.number}</span>
                  <DateStamp value={v.uploaded_at} className="text-xs" />
                </div>
                <FileRow file={v.file} />
                <span className="text-xs text-text-tertiary">
                  {v.uploaded_by.name || '—'}
                  {v.note ? ` · ${v.note}` : ''}
                </span>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  )
}
